export default __webpack_public_path__ + "safari-pinned-tab.38f2ebe2cb94dda85a0fd1c31389e806.svg";